module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","forms"],"commonjs":"@angular/forms","commonjs2":"@angular/forms","amd":"@angular/forms"}
// module id = 3
// module chunks = 0